import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { OptionVerticalIcon, PenPaperIcon, TrashIcon } from '@/icons';
import { Button, Dropdown } from '@/ui_v3';
interface FolderCardMenuProps {
  onEdit?: () => void;
  onDelete?: () => void;
}

/**
 * 폴더 카드의 옵션 메뉴 (수정·삭제).
 *
 * 드롭다운은 **ZUS 것을 쓴다**(`@/ui_v3` 가 `@zep-us/zus/dropdown` 을 재수출). 앱 로컬
 * `@/ui` 의 shadcn 드롭다운을 쓰면 디자인 시스템 밖의 스타일을 따로 들고 가게 된다.
 *
 * ZUS 와 다른 점 둘을 여기서 메운다:
 *  - **Portal 이 자동이 아니다.** `@/ui` 는 Content 가 스스로 Portal 하는데 ZUS 는
 *    `Dropdown.Portal` 을 명시해야 한다. 카드가 `overflow` 를 가진 조상 안에 있어 빼먹으면 잘린다.
 *  - **Content 폭이 트리거 폭에 묶여 있다**(`w-[var(--radix-dropdown-menu-trigger-width)]`).
 *    ZUS 드롭다운은 넓은 트리거(라벨 버튼·프로필)를 전제로 만들어졌는데 여기 트리거는 30px
 *    케밥이라 그대로 두면 메뉴가 30px 이 된다. `w-auto min-w-[8rem]` 로 되돌린다
 *    (`8rem` 은 `@/ui` Content 의 기존 최소 폭과 같은 값이다).
 */
export const FolderCardMenu = ({
  onEdit,
  onDelete
}: FolderCardMenuProps) => {
  const {
    t
  } = useTranslation(['common']);

  /* 카드 전체가 폴더 상세로 가는 링크라, 메뉴 조작은 전파를 끊는다. */
  const stop = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
  };
  return <Dropdown.Root data-sentry-element="unknown" data-sentry-component="FolderCardMenu" data-sentry-source-file="FolderCardMenu.tsx">
      <Dropdown.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="FolderCardMenu.tsx">
        <Button variant={'transparent'} intent={'neutral'} size={'xs'} onClick={stop} data-sentry-element="Button" data-sentry-source-file="FolderCardMenu.tsx">
          <OptionVerticalIcon size={'xs'} data-sentry-element="OptionVerticalIcon" data-sentry-source-file="FolderCardMenu.tsx" />
        </Button>
      </Dropdown.Trigger>
      <Dropdown.Portal data-sentry-element="unknown" data-sentry-source-file="FolderCardMenu.tsx">
        <Dropdown.Content align={'end'} className={'w-auto min-w-[8rem]'} data-sentry-element="unknown" data-sentry-source-file="FolderCardMenu.tsx">
          <Dropdown.Item disabled={!onEdit} onClick={event => {
          stop(event);
          onEdit?.();
        }} data-sentry-element="unknown" data-sentry-source-file="FolderCardMenu.tsx">
            <PenPaperIcon size={'xs'} fill={ICON_COLOR.default} className={'shrink-0'} data-sentry-element="PenPaperIcon" data-sentry-source-file="FolderCardMenu.tsx" />
            {t('global.edit.button')}
          </Dropdown.Item>
          <Dropdown.Item disabled={!onDelete} onClick={event => {
          stop(event);
          onDelete?.();
        }} data-sentry-element="unknown" data-sentry-source-file="FolderCardMenu.tsx">
            <TrashIcon size={'xs'} fill={ICON_COLOR.default} className={'shrink-0'} data-sentry-element="TrashIcon" data-sentry-source-file="FolderCardMenu.tsx" />
            {t('global.delete')}
          </Dropdown.Item>
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>;
};